/* eslint-disable */
// 此文件由 scripts/sync-products-from-xlsx.mjs 自动生成
// 来源: /Users/tency/Desktop/赤松仙/赤松黄大仙货盘-筛选后 2.xlsx
// 请勿手动修改，更新商品信息请重新执行同步脚本

export const RAW_PRODUCTS = [
  {
    "id": 1,
    "name": "生肖百福",
    "type": "手机贴",
    "price": 28,
    "primary_element": "金",
    "secondary_element": "",
    "selling_point": "每个人都有对应的本命属相，与自身的元辰之气紧密相连",
    "tags": [
      "生肖",
      "地支",
      "生肖喜忌",
      "泛祈愿"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "生肖喜忌"
    ],
    "realWorldTags": [
      "泛祈愿",
      "日常随身提醒"
    ],
    "recommendedFor": "想要日常祈福、随身提醒和情绪锚点的人；命理报告判断适合增补/调和对应生肖/地支某个字的人",
    "usage": "贴于手机背面/手机壳；适合日常随身",
    "bundleSuggestion": "可根据报告主诉与喜用五行搭配同类或互补五行产品",
    "imageHint": "19",
    "category": "金箔",
    "sheetRowNum": 2,
    "imageFiles": {
      "main": "main.png",
      "thumbnail": "thumb.png",
      "details": []
    }
  },
  {
    "id": 2,
    "name": "赤珠戒",
    "type": "配饰",
    "price": 48,
    "primary_element": "火",
    "secondary_element": "木",
    "selling_point": "此赤珠戒以橄榄核为基，取其坚韧正气，搭配溏心玛瑙之灵韵 ，能调和自身气场，如道家的护身结界，驱散浊气，辟邪驱凶，助你在人生之路畅行无阻，福运相随",
    "tags": [
      "随身祈福",
      "能量锚点",
      "事业启动",
      "贵人助力"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "事业启动",
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "小人是非",
      "外界干扰",
      "边界不稳",
      "冲煞压力",
      "火气：行动",
      "曝光",
      "热情"
    ],
    "realWorldTags": [
      "工作卡顿",
      "升职转岗",
      "合作谈判",
      "需要贵人助力",
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "处在事业推进、升职转岗、合作谈判阶段的人；近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「火」气的人",
    "usage": "随身佩戴于手部，适合日常提醒与行动锚点",
    "bundleSuggestion": "可与贵人/安神类产品搭配，形成“事业推进+心神稳定”组合",
    "imageHint": "32",
    "category": "戒指",
    "sheetRowNum": 3,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": [
        "detail-1.jpeg"
      ]
    }
  },
  {
    "id": 3,
    "name": "黄晶镇财戒",
    "type": "配饰",
    "price": 58,
    "primary_element": "金",
    "secondary_element": "土",
    "selling_point": "以黄晶为核，玄珠相绕",
    "tags": [
      "生肖",
      "地支",
      "财神",
      "财库"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力",
      "金气：边界",
      "规则",
      "收束",
      "土气：稳定",
      "承载",
      "守成"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；命理报告判断适合增补/调和「金、土」气的人",
    "usage": "随身佩戴于手部，适合日常提醒与行动锚点",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "43",
    "category": "戒指",
    "sheetRowNum": 4,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": [
        "detail-1.jpeg"
      ]
    }
  },
  {
    "id": 4,
    "name": "吸财福袋",
    "type": "挂件",
    "price": 38,
    "primary_element": "火",
    "secondary_element": "土",
    "selling_point": "道家正统吸财福袋，依道家招财古法配伍龙涎香粉； 2、黄绸为引、结饰为扣，搭配道家招财符纹，融龙涎香韵与招财纳福于一体，助你广聚财禄；",
    "tags": [
      "生肖",
      "地支",
      "葫芦",
      "福禄"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力",
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "火气：行动",
      "曝光",
      "热情",
      "土气：稳定",
      "承载",
      "守成"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景",
      "睡眠浅",
      "焦虑内耗",
      "静坐",
      "冥想",
      "空间清净"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；容易焦虑、睡眠浅、想做静坐冥想或空间清净的人；命理报告判断适合增补/调和「火、土」气的人",
    "usage": "随身携带、包内放置，或放在办公抽屉/卧室安稳处",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "55",
    "category": "福袋",
    "sheetRowNum": 5,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": [
        "detail-1.jpeg"
      ]
    }
  },
  {
    "id": 5,
    "name": "万事圣意",
    "type": "挂件",
    "price": 68,
    "primary_element": "木",
    "secondary_element": "木",
    "selling_point": "圣杯造型源自道家阴阳平衡的智慧，红色主火，象征生机与旺运，搭配“诸事皆宜”金牌，寓意阴阳调和、百无禁忌，为你开启顺遂人生",
    "tags": [
      "平安扣",
      "平安守护",
      "太极",
      "阴阳调和"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "小人是非",
      "外界干扰",
      "边界不稳",
      "冲煞压力",
      "金气：边界",
      "规则",
      "收束",
      "木气：成长",
      "启动",
      "舒展",
      "火气：行动",
      "曝光",
      "热情"
    ],
    "realWorldTags": [
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「金、木、火」气的人",
    "usage": "挂于手机、包袋、钥匙、车钥匙等随身物",
    "bundleSuggestion": "可与平安/安神类产品搭配，形成“流年化解+安全感”组合",
    "imageHint": "65",
    "category": "钥匙扣",
    "sheetRowNum": 6,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 6,
    "name": "步步生金",
    "type": "配饰",
    "price": 128,
    "primary_element": "金",
    "secondary_element": "",
    "selling_point": "绳结采用道家“双钱结”古法编织，寓意财运成双、财源滚通，搭配铜镀金金字塔型珠子，契合道家“五帝镇宅、招财纳吉”之说",
    "tags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力",
      "小人是非",
      "外界干扰",
      "边界不稳",
      "冲煞压力",
      "家宅气场",
      "财位布置"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景",
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感",
      "新家",
      "办公桌",
      "店铺陈列",
      "家宅镇守",
      "空间美化"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；近期感觉外界干扰多、犯小人、需要护身安心的人；需要布置家宅、办公室、店铺或财位空间的人；",
    "usage": "随身佩戴于手腕；适合每日佩戴与情绪锚定",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "76",
    "category": "手绳",
    "sheetRowNum": 7,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 7,
    "name": "仙赐福禄",
    "type": "手机贴",
    "price": 68,
    "primary_element": "金",
    "secondary_element": "",
    "selling_point": "葫芦是道家传统的纳福法器，搭配太极八卦阵图，形成“纳福+镇煞”的双重护身格局，既能汇聚福禄财气，又能化解周遭负能量",
    "tags": [
      "生肖",
      "地支",
      "葫芦",
      "福禄"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力",
      "小人是非",
      "外界干扰",
      "边界不稳",
      "冲煞压力",
      "金气：边界",
      "规则",
      "收束"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景",
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「金」气的人",
    "usage": "随身佩戴/摆放，具体按产品形态选择",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "85",
    "category": "金箔",
    "sheetRowNum": 8,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 8,
    "name": "非遗大师芽庄沉香-[盘香]（2小时）",
    "type": "香",
    "price": 298,
    "primary_element": "木",
    "secondary_element": "火",
    "selling_point": "非遗大师将千年的制香智慧与技艺相融合，绝不加半点精油，绝不加半点杂质，无任何化学添加，纯手工打造芽庄沉香盘香",
    "tags": [
      "香",
      "清净",
      "静心",
      "心神不宁"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "木气：成长",
      "启动",
      "舒展",
      "火气：行动",
      "曝光",
      "热情"
    ],
    "realWorldTags": [
      "睡眠浅",
      "焦虑内耗",
      "静坐",
      "冥想",
      "空间清净",
      "亚健康调养",
      "平安安康提醒"
    ],
    "recommendedFor": "容易焦虑、睡眠浅、想做静坐冥想或空间清净的人；重视平安健康、身心调养与日常安康提醒的人；命理报告判断适合增补/调和「木、火」气的人",
    "usage": "静坐、冥想、睡前清净、书房/茶室；注意通风与防火",
    "bundleSuggestion": "可作为咨询/静坐/睡眠改善内容的轻入口，不宜和强功利愿望硬绑",
    "imageHint": "96",
    "category": "盘香",
    "sheetRowNum": 9,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 9,
    "name": "非遗大师芽庄沉香-[盘香]（4小时）",
    "type": "香",
    "price": 0,
    "primary_element": "木",
    "secondary_element": "火",
    "selling_point": "368",
    "tags": [
      "香",
      "清净",
      "静心",
      "心神不宁"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "木气：成长",
      "启动",
      "舒展",
      "火气：行动",
      "曝光",
      "热情"
    ],
    "realWorldTags": [
      "睡眠浅",
      "焦虑内耗",
      "静坐",
      "冥想",
      "空间清净"
    ],
    "recommendedFor": "容易焦虑、睡眠浅、想做静坐冥想或空间清净的人；命理报告判断适合增补/调和「木、火」气的人",
    "usage": "静坐、冥想、睡前清净、书房/茶室；注意通风与防火",
    "bundleSuggestion": "可作为静坐/睡眠改善内容的轻入口，不宜和强功利愿望硬绑",
    "imageHint": "105",
    "category": "盘香",
    "sheetRowNum": 10,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 10,
    "name": "赤松仙别针（招财进宝、儿童款、穗穗平安、健康好运、心想事橙款）",
    "type": "挂件",
    "price": 98,
    "primary_element": "金",
    "secondary_element": "",
    "selling_point": "赤松仙招财进宝别针：鎏金工艺嵌招财珐琅牌，赤松仙加持聚财气，铜钱元宝挂坠招八方财运 赤松仙儿童款别针：重工珐琅彩绘祈福纹，瑞兽+平安扣组合，破煞挡灾保诸事无虞 赤松仙穗穗平安别",
    "tags": [
      "生肖",
      "地支",
      "财神",
      "财库"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力",
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "小人是非",
      "外界干扰"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景",
      "亚健康调养",
      "平安安康提醒",
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；重视平安健康、身心调养与日常安康提醒的人；近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「金」气的人",
    "usage": "随身佩戴/摆放，具体按产品形态选择",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "112",
    "category": "别针",
    "sheetRowNum": 11,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 11,
    "name": "赤松仙-六合好运红绳 加强版（鼠&牛、虎&猪、兔&狗、龙&鸡、蛇&猴、马&羊)",
    "type": "配饰",
    "price": 228,
    "primary_element": "金",
    "secondary_element": "",
    "selling_point": "依道家经典《三命通会》六合生肖命理设计，虎猪/兔狗等六大六合组合，借生肖相生之力调和气场，契合道家“天人合一”的运势平衡理念，从命理根源催旺吉运",
    "tags": [
      "生肖",
      "地支",
      "财神",
      "财库"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力",
      "事业启动",
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "小人是非",
      "外界干扰"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景",
      "工作卡顿",
      "升职转岗",
      "合作谈判",
      "需要贵人助力",
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；处在事业推进、升职转岗、合作谈判阶段的人；近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「金、火」气的人",
    "usage": "随身佩戴于手腕；适合每日佩戴与情绪锚定",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "119",
    "category": "手绳",
    "sheetRowNum": 12,
    "imageFiles": {
      "main": "main.png",
      "thumbnail": "thumb.png",
      "details": [
        "detail-1.jpeg"
      ]
    }
  },
  {
    "id": 15,
    "name": "非遗大师野生檀香-[盘香]（2小时）",
    "type": "香",
    "price": 108,
    "primary_element": "木",
    "secondary_element": "火",
    "selling_point": "非遗大师将道家传承千年的制香古法融入其中，从选料、晾晒到精心盘制，每一个环节都遵循道家的严谨与智慧，完整保留了野生檀香的天然灵性与醇厚香气，让您在使用时，感受道家传统制香技艺的",
    "tags": [
      "香",
      "清净",
      "静心",
      "心神不宁"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "木气：成长",
      "启动",
      "舒展",
      "火气：行动",
      "曝光",
      "热情"
    ],
    "realWorldTags": [
      "睡眠浅",
      "焦虑内耗",
      "静坐",
      "冥想",
      "空间清净",
      "亚健康调养",
      "平安安康提醒"
    ],
    "recommendedFor": "容易焦虑、睡眠浅、想做静坐冥想或空间清净的人；重视平安健康、身心调养与日常安康提醒的人；命理报告判断适合增补/调和「木、火」气的人",
    "usage": "静坐、冥想、睡前清净、书房/茶室；注意通风与防火",
    "bundleSuggestion": "可作为咨询/静坐/睡眠改善内容的轻入口，不宜和强功利愿望硬绑",
    "imageHint": "143",
    "category": "盘香",
    "sheetRowNum": 16,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 16,
    "name": "非遗大师野生檀香-[盘香]（4小时）",
    "type": "香",
    "price": 0,
    "primary_element": "木",
    "secondary_element": "火",
    "selling_point": "128",
    "tags": [
      "香",
      "清净",
      "静心",
      "心神不宁"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "木气：成长",
      "启动",
      "舒展",
      "火气：行动",
      "曝光",
      "热情"
    ],
    "realWorldTags": [
      "睡眠浅",
      "焦虑内耗",
      "静坐",
      "冥想",
      "空间清净"
    ],
    "recommendedFor": "容易焦虑、睡眠浅、想做静坐冥想或空间清净的人；命理报告判断适合增补/调和「木、火」气的人",
    "usage": "静坐、冥想、睡前清净、书房/茶室；注意通风与防火",
    "bundleSuggestion": "可作为咨询/静坐/睡眠改善内容的轻入口，不宜和强功利愿望硬绑",
    "imageHint": "146",
    "category": "盘香",
    "sheetRowNum": 17,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 17,
    "name": "金玉满堂树（陶瓷款）",
    "type": "摆件",
    "price": 0,
    "primary_element": "综合",
    "secondary_element": "",
    "selling_point": "",
    "tags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；处在事业推进、升职转岗、合作谈判阶段的人；近期感觉外界干扰多、犯小人、需要护身安心的人；需要布置家宅、办公室、店铺或财位空间的人；命理报告判断适合增补/调和「水、土」气的人",
    "usage": "家宅、办公桌、书桌、店铺空间陈列",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "46",
    "category": "水晶树",
    "sheetRowNum": 18,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": [
        "detail-1.jpeg"
      ]
    }
  },
  {
    "id": 18,
    "name": "十里桃花树（陶瓷款）",
    "type": "摆件",
    "price": 0,
    "primary_element": "综合",
    "secondary_element": "",
    "selling_point": "",
    "tags": [
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "桃花"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "桃花",
      "正缘",
      "人际连接"
    ],
    "realWorldTags": [
      "工作卡顿",
      "升职转岗",
      "合作谈判",
      "需要贵人助力",
      "想提升桃花",
      "正缘",
      "想改善人际",
      "想增加被看见与亲和力"
    ],
    "recommendedFor": "希望改善人际、桃花、亲密关系或贵人缘的人；需要布置家宅、办公室、店铺的人；命理报告判断适合增补/调和「火」气的人",
    "usage": "家宅、办公桌、书桌、店铺空间陈列",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "34",
    "category": "水晶树",
    "sheetRowNum": 19,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 23,
    "name": "五谷丰登-粮满宝仓",
    "type": "182",
    "price": 38,
    "primary_element": "综合",
    "secondary_element": "",
    "selling_point": "此冰箱贴以真实五谷入仓造型呈现，每一粒五谷都是自然的馈赠，将其巧妙汇聚于粮仓形冰箱贴中，贴于冰箱，仿佛将自然的丰饶引入家中，时刻提醒人们顺应自然、感恩自然的慷慨",
    "tags": [
      "太极",
      "阴阳调和",
      "家宅气场",
      "财位布置"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "家宅气场",
      "财位布置",
      "办公室能量",
      "镇宅安定",
      "木气：成长",
      "启动",
      "舒展"
    ],
    "realWorldTags": [
      "新家",
      "办公桌",
      "店铺陈列",
      "家宅镇守",
      "空间美化"
    ],
    "recommendedFor": "需要布置家宅、办公室、店铺或财位空间的人；命理报告判断适合增补/调和「木」气的人",
    "usage": "家宅、办公桌、书桌、店铺空间陈列",
    "bundleSuggestion": "可与随身平安类产品搭配，形成“空间+个人”双场景",
    "imageHint": "184",
    "category": "",
    "sheetRowNum": 24,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 24,
    "name": "五谷丰登-葫芦纳福",
    "type": "182",
    "price": 0,
    "primary_element": "综合",
    "secondary_element": "",
    "selling_point": "",
    "tags": [
      "葫芦",
      "福禄",
      "纳福",
      "家宅气场"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "家宅气场",
      "财位布置",
      "办公室能量",
      "镇宅安定",
      "木气：成长",
      "启动",
      "舒展"
    ],
    "realWorldTags": [
      "新家",
      "办公桌",
      "店铺陈列",
      "家宅镇守",
      "空间美化"
    ],
    "recommendedFor": "需要布置家宅、办公室、店铺或财位空间的人；命理报告判断适合增补/调和「木」气的人",
    "usage": "家宅、办公桌、书桌、店铺空间陈列",
    "bundleSuggestion": "可与随身平安类产品搭配，形成“空间+个人”双场景",
    "imageHint": "87",
    "category": "",
    "sheetRowNum": 25,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 25,
    "name": "平步青云",
    "type": "配饰",
    "price": 268,
    "primary_element": "金",
    "secondary_element": "水",
    "selling_point": "白水晶为道家“水精”，性清透，对应“青云”意象，助人心神澄澈、运势向上；青金石色属“玄”，契合道家玄远之境，可护持气场，二者皆为天然灵物，得天地之气滋养，佩戴时暗合道家“借自然",
    "tags": [
      "随身祈福",
      "能量锚点",
      "事业启动",
      "贵人助力"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "事业启动",
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "金气：边界",
      "规则",
      "收束",
      "水气：情绪",
      "流动",
      "智慧"
    ],
    "realWorldTags": [
      "工作卡顿",
      "升职转岗",
      "合作谈判",
      "需要贵人助力"
    ],
    "recommendedFor": "处在事业推进、升职转岗、合作谈判阶段的人；命理报告判断适合增补/调和「金、水」气的人",
    "usage": "随身佩戴于手腕；适合每日佩戴与情绪锚定",
    "bundleSuggestion": "可与贵人/安神类产品搭配，形成“事业推进+心神稳定”组合",
    "imageHint": "195",
    "category": "手串",
    "sheetRowNum": 26,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 26,
    "name": "五行长石",
    "type": "配饰",
    "price": 368,
    "primary_element": "金",
    "secondary_element": "木",
    "selling_point": "长石五行手串/项链对应金木水火土，每一颗长石都凝聚了天地间对应五行的本真能量，藏家重“纳福聚气”，道家重“五行平衡”，戴上它，是借长石的天然灵韵，把藏家的“聚气纳福”和道家的“",
    "tags": [
      "随身祈福",
      "能量锚点",
      "心神不宁",
      "睡眠焦虑"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "金气：边界",
      "规则",
      "收束",
      "木气：成长",
      "启动",
      "舒展",
      "水气：情绪",
      "流动",
      "智慧",
      "火气：行动",
      "曝光",
      "热情",
      "土气：稳定",
      "承载",
      "守成"
    ],
    "realWorldTags": [
      "亚健康调养",
      "平安安康提醒"
    ],
    "recommendedFor": "重视平安健康、身心调养与日常安康提醒的人；命理报告判断适合增补/调和「金、木、水、火、土」气的人",
    "usage": "随身佩戴于手腕；适合每日佩戴与情绪锚定",
    "bundleSuggestion": "可根据报告主诉与喜用五行搭配同类或互补五行产品",
    "imageHint": "202",
    "category": "手串",
    "sheetRowNum": 27,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 28,
    "name": "北斗七星结手绳 （大红色、深宝蓝、土黄色、橄榄绿、青绿色）",
    "type": "配饰",
    "price": 68,
    "primary_element": "金",
    "secondary_element": "木",
    "selling_point": "以五行（金、木、水、火、土）和犯太岁为核心，每一种颜色对应不同五行属性（如金黄、木绿、水蓝、火红、土黄），传承千年哲学智慧，将古老文化融入现代饰品，佩戴即感受传统文化的魅力与能",
    "tags": [
      "财神",
      "财库",
      "聚财",
      "太岁"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "财星不稳",
      "财库",
      "守财议题",
      "求财机会",
      "现金流压力",
      "事业启动",
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "学习考试",
      "文昌专注"
    ],
    "realWorldTags": [
      "想提升求财信心",
      "想守住钱",
      "减少损耗",
      "生意",
      "收银",
      "财位场景",
      "工作卡顿",
      "升职转岗",
      "合作谈判",
      "需要贵人助力",
      "备考",
      "考证",
      "学习专注",
      "孩子学业",
      "亚健康调养",
      "平安安康提醒",
      "本命年",
      "流年波动",
      "年底年初祈福"
    ],
    "recommendedFor": "关注财运、现金流、守财与生意收入的人；处在事业推进、升职转岗、合作谈判阶段的人；备考、考证、学习进修或关注孩子学业的人；重视平安健康、身心调养与日常安康提醒的人；本命年、冲太岁、流年波动明显的人；命理报告判断适合增补/调和「金、木、水、火、土」气的人",
    "usage": "随身佩戴于手腕；适合每日佩戴与情绪锚定",
    "bundleSuggestion": "可与安神/平安类产品搭配，形成“求财+稳心+守护”组合；报告中避免只推招财",
    "imageHint": "218",
    "category": "手绳",
    "sheetRowNum": 29,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 29,
    "name": "太极转运珠（金色、银色）",
    "type": "配饰",
    "price": 168,
    "primary_element": "金",
    "secondary_element": "",
    "selling_point": "阴阳造型暗藏东方哲思，内嵌刻福金/银珠，转动间传递福气，传统与时尚兼具",
    "tags": [
      "符箓",
      "祈愿",
      "太极",
      "阴阳调和"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "小人是非",
      "外界干扰",
      "边界不稳",
      "冲煞压力",
      "金气：边界",
      "规则",
      "收束"
    ],
    "realWorldTags": [
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「金」气的人",
    "usage": "贴近心口随身佩戴；适合平安、祈愿、关系与心神类主题",
    "bundleSuggestion": "可与平安/安神类产品搭配，形成“流年化解+安全感”组合",
    "imageHint": "226",
    "category": "项链",
    "sheetRowNum": 30,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 30,
    "name": "有求必应款-福禄葫芦 （白色）",
    "type": "配饰",
    "price": 98,
    "primary_element": "金",
    "secondary_element": "水",
    "selling_point": "葫芦自古是“福禄”象征，白色更添清雅脱俗之感，传承东方文化中“清心寡欲、福运自来”的智慧",
    "tags": [
      "葫芦",
      "福禄",
      "纳福",
      "符箓"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "金气：边界",
      "规则",
      "收束",
      "水气：情绪",
      "流动",
      "智慧"
    ],
    "realWorldTags": [
      "泛祈愿",
      "日常随身提醒"
    ],
    "recommendedFor": "想要日常祈福、随身提醒和情绪锚点的人；命理报告判断适合增补/调和「金、水」气的人",
    "usage": "贴近心口随身佩戴；适合平安、祈愿、关系与心神类主题",
    "bundleSuggestion": "可根据报告主诉与喜用五行搭配同类或互补五行产品",
    "imageHint": "233",
    "category": "项链",
    "sheetRowNum": 31,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 31,
    "name": "有求必应款-福禄葫芦 （紫色）",
    "type": "配饰",
    "price": 0,
    "primary_element": "综合",
    "secondary_element": "",
    "selling_point": "",
    "tags": [
      "葫芦",
      "福禄",
      "纳福",
      "符箓"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "木气：成长",
      "启动",
      "舒展"
    ],
    "realWorldTags": [
      "泛祈愿",
      "日常随身提醒"
    ],
    "recommendedFor": "想要日常祈福、随身提醒和情绪锚点的人；命理报告判断适合增补/调和「火」气的人",
    "usage": "贴近心口随身佩戴；适合平安、祈愿、关系与心神类主题",
    "bundleSuggestion": "可根据报告主诉与喜用五行搭配同类或互补五行产品",
    "imageHint": "34",
    "category": "项链",
    "sheetRowNum": 32,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 32,
    "name": "大仙符管-金色款",
    "type": "配饰",
    "price": 98,
    "primary_element": "金",
    "secondary_element": "",
    "selling_point": "灵性加持：经道士开光加持后，被赋予特殊灵性，可增强佩戴者气场，调节身心状态，助于在生活中保持平和、安宁",
    "tags": [
      "符箓",
      "祈愿",
      "心神不宁",
      "睡眠焦虑"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "心神不宁",
      "睡眠焦虑",
      "身心疲惫",
      "静坐修心",
      "金气：边界",
      "规则",
      "收束"
    ],
    "realWorldTags": [
      "亚健康调养",
      "平安安康提醒"
    ],
    "recommendedFor": "重视平安健康、身心调养与日常安康提醒的人；命理报告判断适合增补/调和「金」气的人",
    "usage": "随身携带、钱包/包内/办公处",
    "bundleSuggestion": "可根据报告主诉与喜用五行搭配同类或互补五行产品",
    "imageHint": "242",
    "category": "项链",
    "sheetRowNum": 33,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": [
        "detail-1.jpeg"
      ]
    }
  },
  {
    "id": 33,
    "name": "大仙符管-银色款",
    "type": "配饰",
    "price": 0,
    "primary_element": "综合",
    "secondary_element": "",
    "selling_point": "",
    "tags": [
      "符箓",
      "祈愿",
      "金气：边界",
      "规则"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "金气：边界",
      "规则",
      "收束"
    ],
    "realWorldTags": [
      "泛祈愿",
      "日常随身提醒"
    ],
    "recommendedFor": "想要日常祈福、随身提醒和情绪锚点的人；命理报告判断适合增补/调和「金」气的人",
    "usage": "随身携带、钱包/包内/办公处",
    "bundleSuggestion": "可根据报告主诉与喜用五行搭配同类或互补五行产品",
    "imageHint": "21",
    "category": "项链",
    "sheetRowNum": 34,
    "imageFiles": {
      "main": "main.jpeg",
      "thumbnail": "thumb.jpeg",
      "details": []
    }
  },
  {
    "id": 34,
    "name": "灵泓映雪",
    "type": "配饰",
    "price": 99,
    "primary_element": "金",
    "secondary_element": "水",
    "selling_point": "以澄澈如冰雪的水晶为主材，能吸纳天地纯净之气的灵物，搭配象征贵气与正阳的金饰，可助佩戴者净化周身浊气，凝神静虑，让内心如映雪之境般纯净无扰",
    "tags": [
      "太极",
      "阴阳调和",
      "事业启动",
      "贵人助力"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "事业启动",
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "小人是非",
      "外界干扰",
      "边界不稳",
      "冲煞压力",
      "金气：边界",
      "规则",
      "收束",
      "水气：情绪",
      "流动",
      "智慧"
    ],
    "realWorldTags": [
      "工作卡顿",
      "升职转岗",
      "合作谈判",
      "需要贵人助力",
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "处在事业推进、升职转岗、合作谈判阶段的人；近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「金、水」气的人",
    "usage": "随身佩戴于手腕；适合每日佩戴与情绪锚定",
    "bundleSuggestion": "可与贵人/安神类产品搭配，形成“事业推进+心神稳定”组合",
    "imageHint": "252",
    "category": "手串",
    "sheetRowNum": 35,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  },
  {
    "id": 35,
    "name": "赤玉佳缘手持",
    "type": "配饰",
    "price": 99,
    "primary_element": "火",
    "secondary_element": "",
    "selling_point": "手串以南红（属阳，代表热烈、吉祥）与草莓晶（属阴，象征温柔、浪漫）搭配，完美诠释阴阳相生、平衡和谐的核心思想",
    "tags": [
      "太极",
      "阴阳调和",
      "事业启动",
      "贵人助力"
    ],
    "link": "",
    "specification": "",
    "issueTags": [
      "事业启动",
      "贵人助力",
      "升迁曝光",
      "合作推进",
      "桃花",
      "正缘",
      "人际连接",
      "关系修复",
      "贵人缘",
      "心神不宁",
      "睡眠焦虑"
    ],
    "realWorldTags": [
      "工作卡顿",
      "升职转岗",
      "合作谈判",
      "需要贵人助力",
      "想提升桃花",
      "正缘",
      "想改善人际",
      "想增加被看见与亲和力",
      "亚健康调养",
      "平安安康提醒",
      "犯小人",
      "出行不安",
      "需要护身",
      "平安感"
    ],
    "recommendedFor": "处在事业推进、升职转岗、合作谈判阶段的人；希望改善人际、桃花、亲密关系或贵人缘的人；重视平安健康、身心调养与日常安康提醒的人；近期感觉外界干扰多、犯小人、需要护身安心的人；命理报告判断适合增补/调和「火」气的人",
    "usage": "随身佩戴于手腕；适合每日佩戴与情绪锚定",
    "bundleSuggestion": "可与贵人/安神类产品搭配，形成“事业推进+心神稳定”组合",
    "imageHint": "257",
    "category": "手串",
    "sheetRowNum": 36,
    "imageFiles": {
      "main": "",
      "thumbnail": "",
      "details": []
    }
  }
] as const;
